<template>
  <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap">
    <h3 class="m-0">
      {{ title }}
    </h3>
    <div class="options">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerDetailActionBar',
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.options {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex: 1 1 auto;
  margin-left: 1rem;
}
</style>
